import { render } from "./AggiungiRicambioModal.vue?vue&type=template&id=47ada3e4"
import script from "./AggiungiRicambioModal.vue?vue&type=script&lang=js"
export * from "./AggiungiRicambioModal.vue?vue&type=script&lang=js"

import "./AggiungiRicambioModal.vue?vue&type=style&index=0&id=47ada3e4&lang=css"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__